module.exports = __webpack_public_path__ + "static/media/join-in-img3-3.58efc0f2.png";